import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useSelector } from "react-redux";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/system';

export default function DefineQuotaTable() {
   const define = useSelector((state) => state.define);
   const { showChart, quotaTableData } = define;
   const PinnedTableCell = styled(TableCell)(({ theme }) => ({
      position: 'sticky',
      left: 0,
      backgroundColor: '#EEF2F4',
      zIndex: 1,
      minWidth: 200,
    }));
    const PinnedHeaderCell = styled(TableCell)(({ theme }) => ({ 
      position: 'sticky', 
      left: 0, 
      top: 0, 
      backgroundColor: '#005587', 
      zIndex: 3, 
      minWidth: 200,
      color : 'white'
   }));
   const { rows = [], cols = [] } = quotaTableData ?? {};
   
   return (
      <Box sx={{ display: showChart ? "none" : "block", mt: 2 }}>
         {/* <DataGrid
            disableColumnMenu
            sx={{minHeight: "450px" , maxHeight: "50vh", "& .MuiDataGrid-cell": { border: "1px solid #000" } }}
            rows={rows}
            columns={cols}
            pagination={false} // Disable pagination 
            hideFooter // Hide footer including pagination controls
            initialState={{ pinnedColumns: { left: ['data'] }, // Pin the first column 
         }}
         ></DataGrid>
          */}

         <TableContainer component={Paper} sx={{ minHeight: "450px", maxHeight: "50vh", overflow: 'auto' }}>
            <Table stickyHeader aria-label="sticky table">
               <TableHead>
                  <TableRow>
                     {cols.map((column, index) => (
                        index === 0 ? (
                           <PinnedHeaderCell key={column.field}><b>{column.headerName}</b></PinnedHeaderCell>
                        ) : (
                           <TableCell key={column.field} style={{ minWidth: column.minWidth, backgroundColor: '#EEF2F4', textAlign : 'center', alignItems: 'center' }}>
                              {column.headerName}
                           </TableCell>
                        )
                     ))}
                  </TableRow>
               </TableHead>
               <TableBody>
                  {rows.map((row) => (
                     <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                        {cols.map((column, index) => {
                           const value = row[column.field];
                           return index === 0 ? (
                              <PinnedTableCell key={column.field}><b>{value}</b></PinnedTableCell>
                           ) : (
                              <TableCell key={column.field} sx={{textAlign : 'center', alignItems: 'center'}}>{value}</TableCell>
                           );
                        })}
                     </TableRow>
                  ))}
               </TableBody>
            </Table>
         </TableContainer>
      </Box>
   );
}
